"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
// Is a given variable an object?
function isObject(obj) {
  var type = typeof obj;
  return type === 'function' || type === 'object' && !!obj;
}